import { useEffect, useState } from "react";
import { MdGroups } from "react-icons/md";
import { IoMdPerson } from "react-icons/io";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { IoCall } from "react-icons/io5";
import Groups from "./ChatTabs/Groups";
import Clients from "./ChatTabs/Clients";
import { FaUserGroup } from "react-icons/fa6";
import { GoArrowLeft } from "react-icons/go";
import { BsSendFill } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import Staff from "./ChatTabs/Staff";
import profile from "../../../Assets/Images/profileicon.jpg";
// import Cookies from "js-cookie";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { set } from "react-hook-form";
import { timeSince } from "../../../utils/helper";
import ChatComponent from "../../../components/ChatComponent";
import Loader from "../../../components/Loader";
import { NavLink } from "react-router-dom";
import Person2Icon from '@mui/icons-material/Person2';
import GroupIcon from '@mui/icons-material/Group';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
const AdminChatInterface = () => {
  const {
    selectedUser,
    messages,
    message,
    setMessage,
    sendMessage,
    handleSelectedUser,
    setShowChatSection,
    showChatSection,
    isSendingMessage,
    user
  } = useGlobalContext();
  const [chatTab, setChatTab] = useState("staff");

  return (
    <div class="shadow-cs pb-0 h-[90vh] overflow-hidden">
      {/* <!-- Container for Chat Section --> */}
      <div class="flex bg-white rounded-lg h-[calc(100vh-55px)] parent-container">
        {/* <!-- Left Section: Members List --> */}
        <div
          className={`w-full ${showChatSection ? "hidden sm:block" : "block"
            } md:w-[417px] flex flex-col border-r-2  h-full bg-white`}
        >
          <div className="flex flex-row justify-start items-center space-x-3 mb-2 p-[10px] pb-[10px] border-b">
            <div className="border-[#27004a] border rounded-full">
              <img src={profile} alt="" className="rounded-full w-9 h-9" />
            </div>
            <p className="font-medium text-xl">{user?.name}</p>
          </div>
          {/* <!-- Search Bar --> */}
          <div class="relative mx-3 mb-0 pb-[5px] border-b">
            <input
              type="text"
              placeholder="Search members..."
              class="border-gray-300 bg-[#f1f1f1] bg-transparent p-[9px] pl-2 rounded-[7px] w-full font-normal text-sm outline-none"
            />
            <IoSearch className="top-0 right-0 absolute mt-1 pr-2 text-[30px] text-gray-400" />
          </div>

          {/* <!-- Member List --> */}
          <div className="flex flex-col flex-grow mb-4 h-full overflow-y-auto">
            <div class="flex justify-between border-b w-full md:w-[100%]">
              <NavLink
                className="flex items-center p-3 border-r w-full text-gray-400 hover:text-black"
                onClick={() => {
                  setChatTab("staff");
                }}
              >
                <Person2Icon /> Staff
              </NavLink>

              <NavLink
                className="flex items-center p-3 border-r w-full text-gray-400 hover:text-black"
                onClick={() => {
                  setChatTab("groups");
                }}
              >
                <GroupIcon />  Groups
              </NavLink>

              <NavLink
                className="flex items-center p-3 w-full text-gray-400 hover:text-black \"
                onClick={() => {
                  setChatTab("clients");
                }}
              >
                <AssignmentIndIcon /> Clients
              </NavLink>
            </div>


            {chatTab === "staff" ? (
              <Staff handleSelectedUser={handleSelectedUser} />
            ) : chatTab === "clients" ? (
              <Clients handleSelectedUser={handleSelectedUser} />
            ) : (
              <Groups />
            )}


            {/* member column in ChatSection */}
          </div>
        </div>

        {/* <!-- Right Section: Chat Window --> */}
        <div class={`w-2/3 h-full md:flex flex-col flex-grow px-[10px] pb-[10px] chat-section ${showChatSection ? "block md:block" : "hidden md:block"} md:block`}>
          {!showChatSection && (
            <div className="flex justify-center items-center h-full">
              <p className="font-normal text-gray-400 text-lg">
                Select a user to start chatting
              </p>
            </div>
          )}
          {showChatSection && (
            <div className="flex flex-col h-full">
              <div className="flex justify-between items-center mt-5 md:mt-0 mb-4 pt-[5px] pb-[11px] border-b">
                <div className="relative flex flex-row justify-start items-center space-x-3 rounded-[100%] w-[70%] md:w-[50%]">
                  <div
                    className="float-left cursor-pointer"
                    onClick={() => {
                      setShowChatSection(false);
                    }}
                  >
                    <GoArrowLeft className="size-5" />
                  </div>
                  <div className="group-hover:text-white flex justify-center items-center border-gray-300 shadow-lg px-4 py-2 border rounded-full">
                    {selectedUser.name[0]}
                  </div>
                  <div className="flex flex-col">
                    <h2 className="font-normal text-md">
                      {selectedUser.name}
                    </h2>
                    {/* <p className="text-gray-300 text-sm">
                      last seen 3 hours ago
                    </p> */}
                  </div>
                </div>
                <div className="flex gap-[10px]">
                  <HiOutlineSpeakerWave className="w-[30px] h-[30px] text-[#27004a]" />
                  <IoCall className="w-[25px] h-[30px] text-[#27004a]" />
                </div>
              </div>
              <ChatComponent messages={messages} />
              <div className="flex items-center mt-4 rounded-xl">
                <div class="relative w-full">
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Send Message..."
                    class="p-2 pr-[70px] border rounded-lg w-full focus-visible:outline-none"
                  />
                  <div class="right-[30px] absolute inset-y-0 flex items-center pr-3">
                    <IoSettingsOutline className="text-2xl text-gray-500" />
                  </div>
                  <button
                    onClick={sendMessage}
                    disabled={isSendingMessage}
                    className={` top-0  flex justify-center items-center absolute text-[#6b7280] text-[20px] right-[8px] p-2 py-3 rounded-xl   ${isSendingMessage && "opacity-50"
                      }`}
                  >
                    <BsSendFill className="text-grey" />
                  </button>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminChatInterface;
